module.exports = __webpack_public_path__ + "static/media/first_change_bee.c1b7518f.mp4";